
import {Component, Prop, Vue} from "vue-property-decorator";
import AuditTrailTable from "@/components/audittrail/AuditTrailTable.vue";
import {auditTrailModule, currentUserModule, usersModule} from "@/store";
import {formatDateTime} from "@/auxillary/date-format";

@Component({
  components: {AuditTrailTable}
})
export default class StudyPatientAuditTrailView extends Vue {
  @Prop({default: ""}) private userId: string;

  get userDisplayName() {
    return usersModule.currentCompleteUser?.displayName ?? "";
  }

  get currentUserDetails() {
    return (currentUserModule.user?.userName ?? "") + " (" + (currentUserModule.roleIdentifier ?? "") + ") " + formatDateTime((new Date().toUTCString()))
  }

  get changes() {
    return auditTrailModule.auditChanges ?? [];
  }

  async mounted() {
    await currentUserModule.loadIfEmpty();
    await usersModule.getCompleteUserById(this.userId);
    await auditTrailModule.loadForUser(this.userId)
  }

  async back() {
    await this.$router.push({name: "usersadmin",}).catch();
  }
}
